// extracted by mini-css-extract-plugin
export default {"host-presence-content__container":"styles_host-presence-content__container__bPkp8","host-presence-content__content":"styles_host-presence-content__content__KMv+Q"};